import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { CreateChannelRequestFilterSensitiveLog, } from "../models/models_0";
import { de_CreateChannelCommand, se_CreateChannelCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class CreateChannelCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("ChimeMessagingService", "CreateChannel", {})
    .n("ChimeSDKMessagingClient", "CreateChannelCommand")
    .f(CreateChannelRequestFilterSensitiveLog, void 0)
    .ser(se_CreateChannelCommand)
    .de(de_CreateChannelCommand)
    .build() {
}
